import http from '@/services/http'

/** 获取运单轨迹页面配置 */
export const getTrackingMeta = () => http.admin.post('/api/tracking/meta')

export interface TrackingSettingFooterItem {
  footerName: string
  footerUrl: string
}

export interface TrackSettingsParams {
  /**图片*/
  logoImageUrl?: string
  logoName?: string
  logoUrl?: string
  removeOsBrand?: boolean
  settingLanguage?: string
  footer?: TrackingSettingFooterItem[]
}

// 运单轨迹页面配置更新
export const postTrackSettings = (params: TrackSettingsParams) => http.admin.post('/api/tracking/setting/update', params)
